<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error':showError}">
        <div class="info">{{'global.infoRequired' | translate}}</div>
        <div class="entry-single" *ngIf="!cultivoFincaId && (this.role === 'Administrador' || this.claims.includes('D_MCV_CultivoDup'))">
            <input type="checkbox" id="duplicarCultivo" formControlName="duplicarCultivos">
            <label for="duplicarCultivo">{{'mantenimientoCultivos.tabs.cultivos.cultivo.duplicarCultivo' | translate}}</label>
        </div>
        <div class="entry-4-modal" *ngIf="!cultivoFincaId && !duplicarCultivo">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.denominacion' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="denominacionesList" [selectedItem]="newEditForm.get('denominacion')" [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal" *ngIf="!cultivoFincaId && !duplicarCultivo">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.campanya' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="campanyas" [selectedItem]="newEditForm.get('campanya')" [disabled]="disabled" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal" *ngIf="!cultivoFincaId && !duplicarCultivo">
            <label>{{'global.finca' | translate}} *</label>
            <input type="text" formControlName="finca">
        </div>

        <div class="entry-4-modal select" *ngIf="!cultivoFincaId && (duplicarCultivo && cultivosDuplicar)">
            <label>{{'global.cultivo' | translate}} *</label>
            <app-filterable-table [columns]="columns" [properties]="properties" [itemsList]="cultivosDuplicar" [selectedItem]="newEditForm.get('cultivosDuplicar')"
            [disabled]="disabledCultivos">
            </app-filterable-table>
        </div>
        <div class="entry-4-modal" *ngIf="!cultivoFincaId && (duplicarCultivo && cultivosDuplicar)">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.denominacion' | translate}} *</label>
            <app-filterable-list class="short-list" [itemsList]="denominacionesList" [selectedItem]="newEditForm.get('denominacionDuplicar')" [disabled]="disabledDenominaciones" [placeHolder]="false"></app-filterable-list>
        </div>
        <div class="entry-4-modal" *ngIf="!cultivoFincaId && (duplicarCultivo && cultivosDuplicar)">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.campanya' | translate}} *</label>
            <input type="text" formControlName="campanyaDuplicar">
        </div>

        <div class="entry-4-modal">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.superficie' | translate}} *</label>
            <input type="number" formControlName="superficie">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.nPlantas' | translate}} *</label>
            <input type="number" formControlName="nPlantas">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.aforo' | translate}} *</label>
            <input type="number" formControlName="aforo">
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.altura' | translate}} </label>
            <input type="number" formControlName="alturaNivelMar">
        </div>
        <div class="entry-4-modal" *ngIf="!cultivoFincaId">
          <label>{{'mantenimientoCultivos.tabs.cultivos.cultivo.designarA' | translate}}</label>
          <app-filterable-list class="shorter-list" [itemsList]="etiquetadores" [selectedItem]="newEditForm.get('etiquetador')" [disabled]="disabledEtiquetadores" [placeHolder]="false"></app-filterable-list>
      </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{cultivoFincaId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
